import { render, staticRenderFns } from "./answerView1.vue?vue&type=template&id=f0520b78&scoped=true"
import script from "./answerView1.vue?vue&type=script&lang=js"
export * from "./answerView1.vue?vue&type=script&lang=js"
import style0 from "./answerView1.vue?vue&type=style&index=0&id=f0520b78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0520b78",
  null
  
)

export default component.exports